import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.user-directories.saaspass-users', {
        url: '/saaspass-users',
        redirectTo: 'company.user-directories.saaspass-users.all-users',
        component: 'companyUserDirectoriesSaaspassUsers',
        resolve: {
            allUsers,
            hardTokens,
            administrators,
            regularUsers,
            hardTokenUsers,
            smsUsers,
            pausedUsers,
            blockedUsers,
			labels,
            numberOfUsers
        },
    });
}

/** @ngInject */
function allUsers(companyId, UsersResource) {
    return UsersResource.getAllRegularCompanyUsers(companyId, 'all');
}

/** @ngInject */
function hardTokens(HardTokenService) {
    return HardTokenService.list().then((items) => items.map((item) => ({...item, blocked: 'NONE'})))
}

/** @ngInject */
function blockedUsers(allUsers) {
    return allUsers.filter((user) => user.blocked !== 'NONE');
}

/** @ngInject */
function administrators(allUsers) {
    return allUsers.filter((user) => user.roleType != 'END_USER');
}

/** @ngInject */
function pausedUsers(allUsers) {
    return allUsers.filter((user) => user.blocked == 'NONE' && user.status == 'PAUSED');
}

/** @ngInject */
function regularUsers(allUsers) {
    return allUsers.filter((user) => user.userType == 'REGULAR_USER' && user.blocked === 'NONE');
}

/** @ngInject */
function hardTokenUsers(allUsers) {
    return allUsers.filter((user) => user.userType == 'HARD_TOKEN_USER');
}

/** @ngInject */
function smsUsers(allUsers) {
    return allUsers.filter((user) => user.userType == 'SMS_USER');
}

/** @ngInject */
function labels(companyId,UserLabelsService){
	return UserLabelsService.getLabels({companyId}).$promise;
}

/** @ngInject */
function numberOfUsers(allUsers, hardTokens, administrators, regularUsers, hardTokenUsers, smsUsers, blockedUsers, pausedUsers){
    let administratorsCount = administrators.length;
    let mobileAppUsersCount = regularUsers.length;
    let hardTokenCount = hardTokens.length;
    let smsUsersCount = smsUsers.length;
    let blockedUsersCount = blockedUsers.length;
    let pausedUsersCount = pausedUsers.length;
    let assignedHardTokenCount = hardTokenUsers.length;
    let allUsersCount = allUsers.length + hardTokenCount - assignedHardTokenCount;
	let numberOfUsers = {
        allUsers: allUsersCount,
        administrators: administratorsCount,
        mobileAppUsers: mobileAppUsersCount,
        hardTokenUsers: hardTokenCount,
        smsUsers: smsUsersCount,
        blockedUsers: blockedUsersCount,
        pausedUsers: pausedUsersCount
    };
    return numberOfUsers;
}


// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/saaspass-users/saaspass-users.state.js